<template>
  <div>
    {{ ActDescBtn }}
    <table :height="this.windowSize.height - 96" :max-height="this.windowSize.height - 96" style="position: absolute"
           width="100%">
      <!-- ContenidoBase-Anular Facturas  -->
      <tr height="48px" max-height="48px">
        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'permite Anular una factura'" :titulo="'Anular Facturas'"
                       @MethodAnular="save" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newnuevo" @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
      <!-- fn ContenidoBase-Anular Facturas  -->
      <tr>
        <!-- BarraPrimaria-Anular Facturas --------------------------------------------------------------------------------->
        <td v-show="BarraPrimariaAbrir" :max-height="this.windowSize.height - 96" width="109">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!--------------------- aqui va la otra tabla izquierda --------->
                <!-- <v-navigation-drawer >  -->
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"> </i>
                      ver
                    </v-btn>

                    <v-btn color="teal darken-2" dark small text @click.prevent="
                      (dialogFiltros = true),
                      (ObjTemTbDinam = JSON.parse(
                        JSON.stringify(Modallfiltro)
                      ))
                    ">
                      <i class="fa fa-search" style="font-size: 25px"> </i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
                </center>

                <BarraDinamicaLimitePlus :ContListSlot="[
  {Text: '#Factura',NomValue: 'facturasventaPK',Nv2: 'secuencia',Ctsl: 2,Type: 0,State: true,},
  {Text: 'Nombre corto',NomValue: 'documentoFactura',Nv2: 'nombrecorto',Ctsl: 2,Type: 0,State: true,},
  {Text: 'Tipo de Anulacion',NomValue: 'motivoAnular',Ctsl: 1,Type: 0,State: true,},
  {Text: 'Fecha',NomValue: 'nuevaFecha',Ctsl: 1,Type: 1,State: true,},
  {Text: 'A pagar $',NomValue: 'valor',Ctsl: 1,Type: 2,State: true,},
  {Text: 'Estado',NomValue: 'activada',Ctsl: 1,Type: 0.2,State: true,},
  { Text: 'Fecha Anulada', NomValue: 'fechaAnulacionNuevo', Ctsl: 1, Type: 1, State: true },
{ Text: 'Usuario Anulación ', NomValue: 'usuariosAnulacion', Ctsl: 1, Type: 0, State: true },
]" :PropsList="ListAnulaFact"
                                         :PropsNombre="'Anular Facturas'" :PropsSeachNombre="'Búsqueda por #Factura'"
                                         :TbPaginator="TbPaginator"
                                         :TbTotalItem="TbTotalItem" :headers="[
                    { text: 'Código', value: 'facturasventaPK.secuencia' },
                    /* { text: 'Nombre', value: 'nombre' },
                  { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]"
                                         PropsSearchNumber @CargarPaginacion="CargarPaginacion" @EmitDAta="datostabla" />

                <!-- <v-navigation-drawer >  -->
                <!-- </v-navigation-drawer> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria-Anular Facturas ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">

          <v-app id="inspire" class="overflow-y-auto"
                 v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">
              <!-- Formulario-Anular Facturas -->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card color="grey lighten-3">
                  <div class="px-2">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- ------------------------------Documentos:-->
                        <v-combobox v-model="anular.documento" :disabled="disabled" :items="RDocumento" :rules="[$rules.required]" autocomplete="off"
                                    dense item-text="descripcion" label="Documentos:"
                                    outlined @blur="SelctCbDocumento" @change="BuscarFactura"
                                    @focus="cargarDocumento">
                          <template v-slot:prepend>
                            <i class="fa fa-book" style="font-size: 30px"></i>
                          </template>
                        </v-combobox>

                        <!-- ----------------------------------------------NCF:-->
                        <v-text-field v-model="anular.ncf" :disabled="disabled" :rules="validaCOntieneNCF(anular)==true?[$rules.required]:[]" autocomplete="off" dense
                                      label="NCF" outlined @blur="BuscarNcf">
                          <template v-slot:prepend>
                            <i class="fa fa-barcode" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!---------------------------------------------- Factura:-->
                        <v-text-field v-model="anular.factura" :disabled="disabled" :rules="[$rules.required]" autocomplete="off" dense
                                      label="Factura" outlined @blur="BuscarFactura"
                                      @keyup="NumeralFac">
                          <template v-slot:prepend>
                            <i class="fa fa-list-alt" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- <Autonumeric
                label="Factura"
                autocomplete="off"
                dense
                outlined
                :rules="[rules.required]"
                v-model="anular.factura"
                @blur="BuscarFactura"
                :disabled="disabled"
              >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-list-alt"></i>
                </template>
              </Autonumeric> -->
                        <!---------------------------------------------- Motivo:-->
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-combobox v-model="anular.tipoAnulacion" :items="RTipoAnulacion" :rules="[$rules.required]" autocomplete="off" dense
                                        item-text="descripcion"
                                        label="Motivo de anulación:" outlined
                                        @blur="SelctCbMotivoAnulacion" v-on="on">
                              <template v-slot:prepend>
                                <i class="fa fa-ban" style="font-size: 20px"></i>
                              </template>
                            </v-combobox>
                          </template>
                          <i class="fa fa-info-circle" dark dense style="font-size: 20px;">
                            <span> Seleccione el motivo de anulación.</span>
                          </i>
                        </v-tooltip>
                      </v-col>
                      <!-- fn columna 2 -->

                      <v-col cols="12" md="8" sm="8">
                        <v-textarea v-model="texAria" rows="38" solo style="font-size: 12px"></v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-form>
              <!-- fn Formulario-Anular Facturas -->
            </div>

            <!-- http://10.0.0.89:8080/backend-leche/servicios/alteza/getAltezasList/%7B%22feche%22:%222019-12-21%22%7D -->
            <!-- <iframe width="auto" width="100%" height="50%"  src="'http://10.0.0.89:8080/backend-leche/servicios/alteza/getAltezasList/%7B%22feche%22:%222019-12-21%22%7D'" outlined >


</iframe> -->

            <!--  <v-card>

      <v-card-title class="headline d-flex justify-center">Factura</v-card-title>






      <v-card-text>{{texAria}}
    
      </v-card-text> 



    </v-card>-->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <!-- <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data todo general -->
    <v-dialog v-model="acti_tb_data" fullscreen hide-overlay label="myAlert" persistent
              transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" dense flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"> </i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"> </i>

          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-if="false" color="deep-purple accent-2" dark small v-on="on"
                     @click.prevent="dialogimprimirListFilt = true">
                <i class="fa fa-print" style="font-size: 25px"> </i>
                Listado
              </v-btn>
            </template>
            <span>Imprimir Listado</span>
          </v-tooltip>

          <v-btn color="grey darken-4" fab small @click="actualiza_tb_ver">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="Modallfiltro.factura" autocomplete="off" hide-details label="Buscar"
                            single-line type="number" @keyup="CargarListTb">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :footer-props="arrayPropiedases" :headers="[
              {
                text: '#Factura',
                value: 'facturasventaPK.secuencia',
                width: 'auto',
                class: ['no-gutters black--text'],
              },
              {
                text: 'Nombre corto',
                value: 'documentoFactura.nombrecorto',
                width: 'auto',
                class: ['no-gutters black--text'],
              },
              { text: 'NCF', value: 'ncf', width: 'auto' },
              {
                text: 'Documento',
                value: 'documentoFactura.descripcion',
                width: 'auto',
                class: ['no-gutters black--text'],
              },
              {
                text: 'Tipo de Anulacion',
                value: 'motivoAnular',
                width: 'auto',
                class: ['no-gutters black--text'],
              },
              {
                text: 'Fecha',
                value: 'fecha',
                width: 'auto',
                class: ['no-gutters black--text'],
              },
              {
                text: 'Valor',
                value: 'valor',
                width: 'auto',
                class: ['no-gutters black--text'],
              },
            ]" :items="ListAnulaFact" :items-per-page="TbPaginator.itemsPerPage" :page="TbPaginator.page"
                          :pageCount="TbPaginator.pageCount" :search="Modallfiltro.factura" :server-items-length="TbTotalItem"
                          class="TbSize13" dense @pagination="cargarPaginacionAll"
                          @click:row="datostabla">
              <template v-slot:item.fecha="props">
                <span>{{ fecFormatter(props.item.fecha) }}</span>
              </template>

              <template v-slot:item.valor="props">
                <span>{{ currencyFormatter(props.item.valor) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn tb-data todo general -->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'AnularCaja'" small @click.prevent="eliminar(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i> Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true" style="margin-top: 20%"
                top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!-- ------------------------------------------------------ Modal-Filtro tb-datos -->
    <v-dialog v-model="dialogFiltros" label="Modal Filtro" max-height="80%" max-width="90%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="indigo" dense flat>
          <i class="" style="font-size: 20px"> </i>
          <v-toolbar-title class="font-weight-light" style="color: white">
            <b>FILTROS</b>
          </v-toolbar-title>
          <i class="" style="font-size: 20px"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="
            (dialogFiltros = false),
            (Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam)))
          ">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br />

          <v-row>
            <v-col cols="12" md="12" sm="12">
              <!-------------------------------------------------- Nombre  -->

              <v-combobox v-model="Modallfiltro.cliente" :items="RCliente" :rules="[$rules.required]" autocomplete="off" dense item-text="nombre"
                          label="Nombre:" outlined @blur="SelctCbCliente"
                          @focus="cargarCliente"
                          @keyup="CbFilcliente">
                <template v-slot:prepend>
                  <i class="fa fa-user-circle" style="font-size: 20px"></i>
                </template>
              </v-combobox>
            </v-col>

            <!-- -----------------------------  columna-1 -->
            <v-col cols="12" md="6" sm="6">
              <!----------------------------------------------  Desde -->
              <v-text-field v-model="Modallfiltro.Desde" dense label="Desde*" outlined type="date">
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-1 -->

            <!-- -----------------------------  columna-2 -->
            <v-col cols="12" md="6" sm="6">
              <!-------------------------------------------------- Hasta -->
              <v-text-field v-model="Modallfiltro.Hasta" dense label="Hasta*" outlined type="date">
                <template v-slot:prepend>
                  <i class="fa fa-calendar" style="font-size: 20px"></i>
                </template>
              </v-text-field>
            </v-col>
            <!-- ----------------------------- fn columna-2 -->
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn-toggle class="" rounded>
            <v-btn color="#90A4AE" dark @click.prevent="Limpiarfiltro">
              <i class="fa fa-file-o" style="font-size: 28px"> </i>
              Limpiar filtro
            </v-btn>

            <v-btn color="blue lighten-1" dark @click.prevent="BuscarFiltros">
              <i class="fa fa-search" style="font-size: 28px"> </i>
              Buscar
            </v-btn>
          </v-btn-toggle>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ fn Modal-Filtro tb-datos-->

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog v-model="dialogimprimirList" label="Modal Reporte Basico" max-height="50%" max-width="80%"
              persistent transition="fab-transition">
      <ModalReporteBasico :Datos="datosImprecion" @DataReporteBasico="DDataReporteBasico" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->

    <!-- ------------------------------------------------------ Modal-Reportes-ModalReporteFiltros-->
    <v-dialog v-model="dialogimprimirListFilt" label="Modal agregar cuenta" max-height="50%" max-width="80%"
              persistent transition="fab-transition">
      <!----------------------------------------------------------------- Cuerpo Reporte -->
      <v-card color="grey lighten-3">
        <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
          <v-avatar size="45" tile>
            <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px">
            <b>REPORTE ANULAR FACTURAS </b>
          </span>

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="dialogimprimirListFilt = false">
            <i class="fa fa-close" style="font-size: 20px; color: white"></i>
          </v-btn>
        </v-toolbar>

        <hr />

        <v-container style="border: 1px solid #000000">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" md="6" sm="6">
                <v-text-field v-model="datosImprecionAll.desde" :rules="[$rules.required]" dense label="Desde*" outlined
                              type="date" @blur="BlurDesde">
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px"></i>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6" sm="6">
                <!-------------------------------------------------- Hasta -->
                <v-text-field v-model="datosImprecionAll.hasta" :rules="[$rules.required]" dense label="Hasta*" outlined
                              type="date" @blur="BlurHasta">
                  <template v-slot:prepend>
                    <i class="fa fa-calendar" style="font-size: 20px"></i>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <hr />

        <ModalReporteFiltros :Datos="datosImprecionAll" @DataReporteBasico="DDataReporteBasico" />
      </v-card>
      <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal-Reportes-ModalReporteFiltros -->

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
</div>
<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <ComponentsPvImprecionViewer ref="RefPvImprecionViewer" />
</div>
</div>
</template>
<script>
import Autonumeric from "../../components/AutoNumericNuevo";
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinamLimite";
import BarraDinamicaLimite from "../../components/BarraDinamicaLimite";
import { EventBus } from "../../event-bus.js";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteBasico from "../../components/ModalReporteBasico";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import { currencyFormatter, FormatoFecha, HoraFormatter,fechaNueva, getParamFecha,RedondeoValor } from "@/js/Funciones.js";
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import ComponentsPvImprecionViewer from "@/PuntodeVenta/UtilidadComponents/PvImprecionViewer.vue";
export default {
  components: {
    BarraDinamicaLimite,
    BarraDinamicaLimitePlus,
    BarraBusqueda2,
    Autonumeric,
    ContenidoBase,
    ModalReporteBasico,
    ModalReporteFiltros,
    PvDgiiFacturacionEletronica,
    ComponentsPvImprecionViewer
  },
  mounted() {
    console.log("Mount-Inf")
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("emitAnular", this.datostabla)
    EventBus.$on("AnularNew", this.new)
    // EventBus.$on("AnularSave", this.save);
    EventBus.$on("AnularRemove", this.remove)
    EventBus.$on("AnularAnular", this.save)
    EventBus.$on("AnularPrintList", this.imprimirList)
    this.cargar()

    //nota:filtrar barraDinamicalimitada
  },

  created() {
    var json = {
      titulo: "Anular Facturas",
      descripcion: "permite Anular una factura",
      save: false,
      eliminar: false,
      anular: true,
      nuevo: true,
      imprimir: true,
      accion: [
        "AnularNew",
        "AnularSave",
        "AnularRemove",
        "AnularAnular",
        "AnularPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  data() {
    return {
      windowSize: { width: "auto", height: "auto" },
      RTipoAnulacion: [
        { codigo: 1, descripcion: "Deterioro de Factura Pre-Impresa" },
        { codigo: 2, descripcion: "Errores de Impresión(Factrua Pre-Impresa" },
        { codigo: 3, descripcion: "Impresión Defectuosa" },
        { codigo: 4, descripcion: "Duplicidad de Factura" },
        { codigo: 5, descripcion: "Correción de la Información" },
        { codigo: 6, descripcion: "Cambio de Productos" },
        { codigo: 7, descripcion: "Devolución de Productos" },
        { codigo: 8, descripcion: "Omisión de Productos" },
        { codigo: 9, descripcion: "Errorres en la secuencias NCF" },
      ],

      EstadoBtn: {
        BarraTablaDinamicaAprir: true,
        nuevo: true,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: true,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      Rrutas: [
        { codigo: 0, desc: "1" },
        { codigo: 1, desc: "2" },
        { codigo: 2, desc: "3" },
        { codigo: 3, desc: "4" },
        { codigo: 5, desc: "5" },
      ],

      RDocumento: [],
      RCliente: [],
      RVer: null,
      texAria: null,
      valid: true,

      anular: {
        documento: null,
        factura: 0,
        ncf: null,
        tipoAnulacion: null,
      },

      dialogimprimirListFilt: false,

      datosImprecionAll: {
        nombre: "ANULAR FACTURAS",
        UrlImprimir: "/AnularFactura/ImprimirList",
        UrlExel: "/AnularFactura/ExcelList",
        UrlCorreo: "/AnularFactura/CorreoList",
        desde: new Date().toISOString().substr(0, 10),
        hasta: new Date().toISOString().substr(0, 10),
        documentos: null,
      },

      dialogimprimirList: false,
      datosImprecion: {
        nombre: "ANULAR FACTURAS",
        UrlImprimir: "/AnularFactura/Imprimir/",
        UrlExel: "/AnularFactura/Excel/",
        UrlCorreo: "/AnularFactura/Correo/",
        codigo: 0,
        documento: 0,
      },

      dialogFiltros: false,

      Modallfiltro: {
        factura: null,
        cliente: null,
        Desde: null,
        Hasta: null,
      },

      ObjTemTbDinam: null,
      ListAnulaFact: [],
      TbTotalItem: 0,
      TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },
      arrayPropiedases: {
        "items-per-page-options": [10, 15, 20, 50],
        "items-per-page-text": "Cantidad de Registros Por Paginas",
        showFirstLastPage: false,
      },
      headers: [{ text: "#Factura", value: "facturasventaPK.secuencia" }],

      slotlist: [
        {
          dt0: "facturasventaPK",
          dt1: "secuencia",
          dt2: null,
          dt3: 1,
          dt4: "#Factura:",
        },
        {
          dt0: "documentoFactura",
          dt1: "nombrecorto",
          dt2: null,
          dt3: 1,
          dt4: "Nombre corto:",
        },
        {
          dt0: "motivoAnular",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Tipo de Anulacion:",
        },
        { dt0: "fecha", dt1: null, dt2: null, dt3: 2, dt4: "Fecha:" },
        { dt0: "valor", dt1: null, dt2: null, dt3: 5, dt4: "A pagar: $" },
        { dt0: "activada", dt1: null, dt2: null, dt3: 0.1, dt4: "Anulada" },

        // { dt0: "tasaCompra", dt1: null, dt2: null, dt3: 5, dt4: "Tasa de compra:" },
        // { dt0: "tasaVenta", dt1: null, dt2: null, dt3: 5, dt4: "Tasa de Venta:" }
      ],

      //{ dt0: "sucursal", dt1:"documentofacturacion", dt2: "nombrecorto", dt3: 1, dt4: "Nombre corto:" },

      list: [],
      search: "",
      acti_tb_data: false,

      limiteTotalRegistros: 0,
      paginator: {
        itemsPerPage: 15,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      ejecucion: true,
      aalert: {
        estado: false,
        color: null,
      },

      notif: {
        estado: false,
        nombre: "",
        Exec: "",
      },

      Colss: {
        p1: 8,
      },
      disabled: false,

      BarraPrimariaAbrir: false,
      BarraSecundariaAprir: false,
    }
  },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    fechaNueva,
    getParamFecha,
    RedondeoValor,
    // Llamar a una API y devolver los datos de un lista de cliente.
    cargarCliente() {
      this.$axios
        .get(this.$hostname + this.$hName + "/clientes/findCombo/A/25", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RCliente = res.data))
    },

    // Hacer una llamada API al servidor y devolver los datos al cliente.
    CbFilcliente(e) {
      this.RCliente = []
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/clientes/findtodo/" +
            (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
            "/3/25/0",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            this.RCliente = res.data
          })
      }
    },

    // Al verificar si el cliente es nulo, si es nulo, establece el cliente en una cadena vacía.
    SelctCbCliente() {
      if (this.Modallfiltro.cliente == null) {
        this.Modallfiltro.cliente = ""
      }

      if (this.Modallfiltro.cliente.codigo == undefined) {
        this.alerta("Seleccione un cliente", "error")
        this.Modallfiltro.cliente = ""

        //qlq2

        return
      }
    },

    cargar() {
      //  this.$axios.post(this.$hostname + this.$hName +'/services/AnularFactura/totalRegistrosFacturasAnuladas', {})
      // .then(res => (this.limiteTotalRegistros = res.data.totalRegistros, this.filtro()));
    },

    documentoSeleccionadoValido(documento) {
      return documento != null && typeof documento === "object" && documento.codigo != null
    },

    facturaSeleccionadaValida() {
      return this.anular.facturasventa != null &&
        this.anular.facturasventa.facturasventaPK != null &&
        this.anular.facturasventa.facturasventaPK.secuencia != null &&
        this.anular.facturasventa.facturasventaPK.documento != null
    },

    limpiarFacturaSeleccionada() {
      this.$delete(this.anular, "facturasventa")
      this.anular.movimiento = false
      this.texAria = null
      this.EstadoBtn.anular = false
    },

    fecFormatter(params) {
      if (params != null) {
        if (params.length > 0) {
          return (
            params.substring(8, 10) +
            "-" +
            params.substring(5, 7) +
            "-" +
            params.substring(0, 4)
          )
        }
      }
    },

    cargarPaginacion(e) {
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
      }

      this.filtro()
    },

    NumeralFac(e) {
      if (e.key) {
        var mynumeral = require("numeral")
        this.anular.factura = mynumeral(this.anular.factura).value()
        if (this.anular.factura == null) {
          this.anular.factura = 0
        }
      } else {
        console.log("no se puede poner letras o signos")
      }
    },


    // Abriendo una la barra de datos principal.
    abrirTabla() {
      this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir

      if (this.abrirTablaDinamica == true) {
        this.Limpiarfiltro()
      }
    },
    abrirTabla2() {
      this.BarraSecundariaAprir = !this.BarraSecundariaAprir
    },

    // Realizar una solicitud GET al servidor y devolver los datos documento.
    cargarDocumento() {
      this.$axios
        .get(this.$hostname + this.$hName + "/documentoventas/findallActivos", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RDocumento = res.data))
    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbDocumento() {
      if (this.anular.documento == null) {
        this.anular.documento = ""
      }

      if (this.anular.documento.codigo == undefined) {
        this.alerta("Seleccione un documento", "error")
        this.anular.documento = ""
        return
      }
    },

    // Realización de una solicitud al servidor para traer la factura.
    BuscarNcf() {
      if (this.anular.ncf != null && this.anular.ncf.trim() !== "") {
        this.limpiarFacturaSeleccionada()
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/AnularFactura/findNCF/" +
            this.anular.ncf,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            if (res.data != "" && res.data != null && res.data.facturasventaPK != null) {
              this.disabled = true
              this.anular.documento = res.data.documentoFactura
              this.anular.factura = res.data.facturasventaPK.secuencia
              this.cantRegistro(res.data)
              this.cambiaEstatus()
            } else {
              this.alerta("No se encontro una factura con ese NCF.", "error")
            }
          })
          .catch((error) => this.alerta(error.response ? error.response.data : error, "error"))
      }
    },

    // Llamar a un método api para traer la factura en texto
    cantRegistro(e) {
      if (e == null || e.facturasventaPK == null) {
        this.limpiarFacturaSeleccionada()
        return
      }

      this.anular.facturasventa = e
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/AnularFactura/FacturaText/" + e.facturasventaPK.secuencia + "/" + e.facturasventaPK.documento,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          this.texAria = res.data

        })
        .catch((error) => this.alerta(error.response ? error.response.data : error, "error"))
    },

    // Realización de una solicitud al servidor para obtener los datos de la factura.
    BuscarFactura() {
      if (!this.documentoSeleccionadoValido(this.anular.documento) || this.anular.factura == null || Number(this.anular.factura) <= 0) {
        this.limpiarFacturaSeleccionada()
        return
      }

      if (this.anular.factura != null && this.anular.documento != null) {
        this.limpiarFacturaSeleccionada()
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/AnularFactura/findNFactura/" + this.anular.factura + "/" + this.anular.documento.codigo,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            if (res.data != "" && res.data != null && res.data.facturasventaPK != null) {
              this.disabled = true
              this.anular.documento = res.data.documentoFactura
              this.anular.factura = res.data.facturasventaPK.secuencia
              this.anular.ncf = res.data.ncf
              // this.anular.movimiento = (res.data.cxc > 0 && res.data.valor != res.data.pendiente)
              this.anular.movimiento = (res.data.cxc > 0 && res.data.cxc != res.data.pendiente)
              this.cantRegistro(res.data)
              this.cambiaEstatus()
            } else {
              this.alerta("No se encontro la factura indicada para el documento seleccionado.", "error")
            }
          })
          .catch((error) => this.alerta(error.response ? error.response.data : error, "error"))
      }
    },

    BlurDesde() {
      if (this.datosImprecionAll.desde.toString().length == 0) {
        this.datosImprecionAll.desde = new Date().toISOString().substr(0, 10)
      }
    },

    BlurHasta() {
      if (this.datosImprecionAll.hasta.toString().length == 0) {
        this.datosImprecionAll.hasta = new Date().toISOString().substr(0, 10)
      }
    },


    SelctCbMotivoAnulacion() {
      var _this = this
      setTimeout(function() {
        if (_this.anular.tipoAnulacion == null) {
          _this.anular.tipoAnulacion = ""
        }

        if (!_this.anular.tipoAnulacion.hasOwnProperty("codigo")) {
          _this.anular.tipoAnulacion = ""
          _this.anular.tipoAnulacion = null
          return
        }
      }, 300)
    },


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)

        this.ejecucion = true
        EventBus.$emit("loading", false)
      }
      this.$emit("DataRetornAlerta", e,l)
    },

    // Limpia el formulario.
    newnuevo() {
      this.BarraPrimariaAbrir = false

      this.anular = {
        documento: null,
        factura: 0,
        ncf: null,
        tipoAnulacion: null,
        movimiento: false,
      }
      this.texAria = null
      this.disabled = false

      this.ejecucion = true
      EventBus.$emit("actualizaBarraBusqueda2")
      EventBus.$emit("loading", false)
    },

    // Llamar a una función que se define en la sección de métodos del componente Vue para imprimir reporte.
    imprimirList() {
      if (!this.documentoSeleccionadoValido(this.anular.documento)) {
        this.alerta("Seleccione un documento antes de imprimir.", "error")
        return
      }

      this.dialogimprimirList = true
      this.datosImprecion.codigo = this.anular.factura
      this.datosImprecion.documento = this.anular.documento.codigo
    },
    DDataReporteBasico(e) {
      this.dialogimprimirList = e
    },

    // Envío de una solicitud POST al servidor y guarda la anulacion.
    save() {
      if (this.$refs.form.validate()) {
        if (!this.facturaSeleccionadaValida()) {
          this.alerta("Debe buscar y seleccionar una factura valida antes de anular.", "error")
          return
        }

        var link = `${this.anular.facturasventa.facturasventaPK.secuencia}/${this.anular.facturasventa.facturasventaPK.documento}`
        this.$axios
          .get(
            this.$hostname + this.$hName + "/devolucion/devolucionFactura/" + link,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then((res) => {
            if (res.data == true) {
              this.alerta("Esta factura no puede ser anulada, porque tiene devoluciones de venta aplicada", "error")
              return
            } else {
              // En electronicas el API distingue cobros previos de la NC del mismo reintento.
              if (this.anular.movimiento && !this.anular.facturasventa.signatureValue) {
                this.alerta("Esta factura no se puede anular ya que posee algún movimiento.", "error")
                return
              }

                     if(this.anular.facturasventa.hasOwnProperty('domicilio') && this.anular.facturasventa.domicilio!=null){
      //  if(this.anular.facturasventa.domicilio.hasOwnProperty('mensajero')&& this.anular.facturasventa.domicilio.mensajero!=null){
       // this.alerta("No puede hacer una anulación de esta factura porque esta asignada a un mensajero. se debe realizar el proceso de no entregada", "error");
       // return
       // }
      }
        if (this.ejecucion == true) {
          this.ejecucion = false;
          EventBus.$emit("loading", true);

          //this.hacerAnulacion()

        var BOOL_ELET= this.anular.facturasventa.hasOwnProperty("signatureValue") && this.anular.facturasventa.signatureValue !=null;

        if(BOOL_ELET==true){
          return this.continuandoFinalizarDevolucionFactura(this.anular)
            }else{
         this.hacerAnulacion(this.anular)
            }


        }

                  }

                  })
          .catch((error) => {
            this.alerta(error.response ? error.response.data : error, "error")
          });


      } else {
        this.alerta("los campos en rojo son requeridos", "error");
      }
    },


    hacerAnulacion(OBJ_DATA){

      var OBJ= JSON.parse(JSON.stringify(OBJ_DATA))
      /* ORIGINAL
      this.anular.facturasventa.motivoAnular = this.anular.tipoAnulacion.descripcion;
          this.anular.facturasventa.usuariosAnulacion=this.$store.getters.GetdatosInfUsu.usuario.usuario
          this.anular.facturasventa.fechaAnulacion=this.fechaNueva()+"T04:00"
          this.anular.facturasventa.fecha=this.getParamFecha(this.anular.facturasventa.fecha)
          this.$axios
            .post(
              this.$hostname + this.$hName + "/AnularFactura/save/",
              this.anular.facturasventa,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => this.alerta("Dato Anulado correctamente", "bien"))
            .catch((error) => this.alerta(error, "error"));*/


          OBJ.facturasventa.motivoAnular = OBJ.tipoAnulacion.descripcion;
          OBJ.facturasventa.usuariosAnulacion=this.$store.getters.GetdatosInfUsu.usuario.usuario
          OBJ.facturasventa.fechaAnulacion=this.fechaNueva().trim().substr(0, 10) +"T04:00"
          OBJ.facturasventa.fecha=this.getParamFecha(OBJ.facturasventa.fecha)
          this.$axios
            .post(
              this.$hostname + this.$hName + "/AnularFactura/save/",
              OBJ.facturasventa,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => this.alerta("Dato Anulado correctamente", "bien"))
            .catch((error) => {
              this.alerta(error.response.data, "error")
            });
    },



 async continuandoFinalizarDevolucionFactura(FAC_DATA) {
try {
var DEV_FAC_SEL= JSON.parse(JSON.stringify(FAC_DATA.facturasventa))

  // if(DEV_FAC_SEL.hasOwnProperty('domicilio') && DEV_FAC_SEL.domicilio!=null && DEV_FAC_SEL.domicilio.facturado==false){
  // var BOOLMEN=(!DEV_FAC_SEL.hasOwnProperty('mensejero') || DEV_FAC_SEL.hasOwnProperty('mensejero') && DEV_FAC_SEL.mensejero==null )

  // if(BOOLMEN==true ){
  //   if(DEV_FAC_SEL.DetalleList.length!= DEV_FAC_SEL.SeletDetalleList.length || DEV_FAC_SEL.valortotal!=DEV_FAC_SEL.domicilio.valor ){
  //     this.alerta('Esta factura es de domicilio y no esta asignada a un mensajero, debe de anular o hacer la devolución completa.', "error");
  //     return
  //   }
  // }

  // }

      EventBus.$emit("loading", true);
      //var l = this.DevolucionSelected[0];
      var l = JSON.parse(JSON.stringify(DEV_FAC_SEL));
      if(l.hasOwnProperty('horaFactura')){
          delete l["horaFactura"]
      }


      var domnoentre=null
        if(DEV_FAC_SEL.hasOwnProperty('domicilionoentregado')&&DEV_FAC_SEL.domicilionoentregado!=null){
          domnoentre=DEV_FAC_SEL.domicilionoentregado
        }


     //var ObjBOOLquitaritbis = this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.hasOwnProperty('productos')&& ee.productos!=null&&ee.quitaritbis == true);

    var ObjBOOLquitaritbis=false

      var devolucion = {
        devoclucionPK: { documento: 0, secuencia: 0 },
        // fecha: new Date(),
        fecha: fechaNueva().trim().substr(0,10)+"T04:00",
        referencia: "",
        valor: 0.0,
        valorItbis: 0.0,
        usuario: this.$store.getters.GetdatosInfUsu.usuario.codigo,
        ncf: "",
        // caja:null,
         caja: FAC_DATA.hasOwnProperty('caja')? FAC_DATA.caja.codigo :DEV_FAC_SEL.caja.codigo,
         numerocierre:FAC_DATA.hasOwnProperty('numerocierre')? FAC_DATA.numerocierre: null,
       // efectivo: this.DevolucionFacturaSeleccionada.efectivo,
        efectivo: DEV_FAC_SEL.cxc==0&& DEV_FAC_SEL.efectivo ?true:false,
        // quitaritbis: this.DevolucionFacturaSeleccionada.quitaritbis,
        quitaritbis: ObjBOOLquitaritbis.length>0,
        cobertura: null,
        fechaImpresion: null,
        nif: null,
        horaImpresion: null,
        comentario: FAC_DATA.tipoAnulacion.descripcion,
        borrado: false,
        devolucionDetalleList: [],
        facturasventa: DEV_FAC_SEL,
        nombre: DEV_FAC_SEL.cliente!=null? DEV_FAC_SEL.cliente.nombre.trim():`contado`,
        cedula: DEV_FAC_SEL.cliente && DEV_FAC_SEL.cliente.cedrnc ? DEV_FAC_SEL.cliente.cedrnc.trim() : null,
        notacreditocontado: null,
        notacreditoclientes: null,
        documentoinventario: null,
       // almacen: this.caja.almacen,
        almacen:DEV_FAC_SEL.caja.almacen,
        activo: false,
        domicilionoentregado: domnoentre,
        moneda:DEV_FAC_SEL.moneda,
        tasa:DEV_FAC_SEL.tasa,
       // devtarjeta:this.DevolucionFacturaSeleccionada.devtarjeta,
       devtarjeta:DEV_FAC_SEL.cxc==0 && DEV_FAC_SEL.tarjeta>0?true:false,
       qrdgii:null,
       signatureValue:null,
       trackId:null,
       fechafirmadgii:null,
       valor:DEV_FAC_SEL.valor
       /* qrdgii:this.DevolucionFacturaSeleccionada.hasOwnProperty("qrdgii") && this.DevolucionFacturaSeleccionada.qrdgii != null ? this.DevolucionFacturaSeleccionada.qrdgii : null,
        signatureValue:this.DevolucionFacturaSeleccionada.hasOwnProperty("signatureValue") && this.DevolucionFacturaSeleccionada.signatureValue != null ? this.DevolucionFacturaSeleccionada.signatureValue : null,
        trackId:this.DevolucionFacturaSeleccionada.hasOwnProperty("trackId") && this.DevolucionFacturaSeleccionada.trackId != null ? this.DevolucionFacturaSeleccionada.trackId : null,
        fechafirmadgii:this.DevolucionFacturaSeleccionada.hasOwnProperty("fechafirmadgii") && this.DevolucionFacturaSeleccionada.fechafirmadgii != null ? this.DevolucionFacturaSeleccionada.fechafirmadgii : null
      */
      };
// ${DEV_FAC_SEL.facturasventaPK.secuencia} 
      if(FAC_DATA.hasOwnProperty('caja') && FAC_DATA.caja !=null){
        devolucion.datacaja=JSON.parse(JSON.stringify(DEV_FAC_SEL.caja))
      }

       if(FAC_DATA.hasOwnProperty('sucursal') && FAC_DATA.sucursal !=null){
        devolucion.datasucursal=JSON.parse(JSON.stringify(DEV_FAC_SEL.sucursal))
      }

     // this.devolucion.devolucionDetalleList = [];
    var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote

//&&ee.cantidadPendiente > 0
     await Promise.all(DEV_FAC_SEL.facturasventaDetalleList.
    filter((ee) => ee.hasOwnProperty('productos')&& ee.productos!=null&&ee.cantidad > 0).map(async (d) => {
      //this.detalleDevolucion(d);

      var det = {
        cantidad: d.cantidad,
        precio: d.precio,
        costo: d.costounidad,
        codigo: 0,
        documentofactura: null,
        borrado: false,
        producto: d.productos,
        unidad: d.unidades,
        quitaritbis:false,
        valordescuento: d.valordescuento,
        valorimpuesto: d.valorimpuesto
      };
      if(UsarLote==true){
        det.lote=d.facturasventaDetallePK ? d.facturasventaDetallePK.lote : d.lote
      }

      det.valor= this.RedondeoValor(((d.precio-(d.valordescuento/d.cantidad))+d.valorimpuesto)*d.cantidad)
      //devolucion.valor+= det.valor;
      devolucion.devolucionDetalleList.push(det);

       // devolucion.valor = devolucion.valor + d.valor;
      // devolucion.valor = devolucion.valor + (d.precio*d.cantidad);
      if(d.quitaritbis==true){
          devolucion.valorItbis=0
      }else{
        devolucion.valorItbis=devolucion.valorItbis+(d.cantidad*d.valorimpuesto)
        //this.devolucion.valorItbis = this.devolucion.valorItbis + d.valor;
      }
     }));

     //this.saveDevolucion();
     // El API valida el detalle persistido y recupera la misma devolucion al reintentar.
     return await this.saveDevolucion(devolucion);
} catch (error) {
  this.alerta(error.response ? error.response.data : error.message || error, "error")
} finally {
  this.ejecucion = true
  this.loading(false)
  EventBus.$emit("loading", false)
}
    },

async detalleDevolucion(datos) {
   var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
      var det = {
        cantidad: datos.cantidad,
        precio: datos.precio,
        costo: datos.costounidad,
        codigo: 0,
        documentofactura: null,
        borrado: false,
        producto: datos.productos,
        unidad: datos.unidades,
      };
      if(UsarLote==true){
        det.lote=datos.lote
      }

      this.devolucion.devolucionDetalleList.push(det);
    },


preValidarSaveDevolucion(devolucion){



  // this.devolucion
  this.$axios.post(
            this.$hostname + this.$hName + "/devolucion/verificarDevolucion",
            devolucion,
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
          if(res.data.continuarDev==false){
            this.alerta(res.data.mensage, res.data.estado)
 //DevolucionFacturaSeleccionada.SeletDetalleList
            //DevolucionFacturaSeleccionada.DetalleList

            devolucion.facturasventa.facturasventaDetalleList.filter((ee) => ee.facturasventaDetallePK.producto == res.data.producto &&
            ee.facturasventaDetallePK.unidad == res.data.unidad &&
            ee.facturasventaDetallePK.secuencia == res.data.secFac &&
            ee.facturasventaDetallePK.documento == res.data.docFac
            )[0].cantidadPendiente= res.data.catPendiente;

            devolucion.facturasventa.facturasventaDetalleList.filter((ee) => ee.facturasventaDetallePK.producto == res.data.producto &&
            ee.facturasventaDetallePK.unidad == res.data.unidad &&
            ee.facturasventaDetallePK.secuencia == res.data.secFac &&
            ee.facturasventaDetallePK.documento == res.data.docFac
            )[0].cantidadPendiente= res.data.catPendiente;

          }
          if(res.data.continuarDev==true){
              this.saveDevolucion(devolucion)
          }

          })
          .catch((error) => {
            this.loading(false)
            if (error.response) {
              this.alerta(error.response.request.responseText, "error");
            } else {
              this.alerta(error, "error");
            }
          });

},

 // Envío de una solicitud POST al servidor guardando la devolucion.
    saveDevolucion(devolucion) {

      //var doc=this.caja.sucursal

      //console.log(devolucion.facturasventa)

      /*console.log('info-SUCURSAL->',this.caja.sucursal)
      console.log('info-FACTURA->',this.devolucion)
      devClientes.documentoNotaCredito*/

var SUCURSAL= devolucion.hasOwnProperty('datasucursal')? devolucion.datasucursal:devolucion.facturasventa.caja.sucursal
var CAJA= devolucion.hasOwnProperty('datacaja')?devolucion.datacaja : devolucion.facturasventa.caja

var DOC_NOTACREDITO_CXC=SUCURSAL.documentoNotaCredito

if (devolucion.devolucionDetalleList.length > 0) {

            if(DOC_NOTACREDITO_CXC.comprobante==true){
          //-->/secuenciaComprobantes/existesecuencia/
        // var link = resdoc.data.codigo +"/" + "CXC"
        var link = DOC_NOTACREDITO_CXC.codigo +"/" + "CXC/"+SUCURSAL.rnc.trim()
        return this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + link,
          { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            if (res.data == true) {

        var docDev=SUCURSAL.documentoDevolucion
      return this.$axios.get(this.$hostname + this.$hName +"/documento-inv/"+docDev,
          { headers: this.$store.getters.GetheadersAxios }).then(resdocInv => {
 var BOOL_ELET= SUCURSAL.facturacionEletronica==true && CAJA.facturacionEletronica==true;

if(BOOL_ELET==true && resdocInv.data.comprobante==false){
  this.alerta(`Nota: Esta caja esta asignada como facturador electrónico y el documento: "${resdocInv.data.nombrecorto}- ${resdocInv.data.descripcion}". no genera comprobante.`,"error")
  return
}

return this.ContinuarsaveDevolucion(devolucion)

 })
.catch(error => {
        this.alerta(error, "error")
        this.loading(false)
           });

            } else {
              this.alerta("No posee secuencia para la Notas de Crédito que está intentado realizar", "error")
            }
          })
          .catch(error => {
        this.alerta(error, "error")
        this.loading(false)

           });

      }else{
        return this.ContinuarsaveDevolucion(devolucion)
      }

          }else{
        this.ejecucion = true
        EventBus.$emit("loading", false);
          }


    //  var doc=this.caja.sucursal.documentoNotaCredito

      /*this.$axios.get(this.$hostname + this.$hName +"/documentocxc/find/"+doc,
          { headers: this.$store.getters.GetheadersAxios }
        ).then(resdoc => {
        });*/
    },

async ContinuarsaveDevolucion(devolucion){

      if (devolucion.devolucionDetalleList.length > 0) {
        //this.devolucion.usuario=this.$store.getters.GetOtrasConfigPv.cajero
        devolucion.documentocxcNotacredito=devolucion.facturasventa.caja.sucursal.documentoNotaCredito
        this.loading(true)
        var electronica = Boolean(devolucion.facturasventa.signatureValue)
        var endpoint = electronica ? "/devolucion/saveAnulacionElectronica" : "/devolucion/save"
        return this.$axios.post(
            this.$hostname + this.$hName + endpoint,
             devolucion,
            { headers: this.$store.getters.GetheadersAxios}
          )
          .then((res) => {
            if (electronica) {
              return this.DevolucionEletronicaGet(res.data)
            }
            this.devolucion = res.data
            return this.enviarImprimirDevolucion(res.data)

         // this.enviarImprimirDevolucion(res.data)

          })
          .catch((error) => {
            this.loading(false)
            if (error.response) {
              this.alerta(error.response.request.responseText, "error");
            } else {
              this.alerta(error, "error");
            }
          });
      }else{
        this.ejecucion = true
        EventBus.$emit("loading", false)
      }
    },

validarRespuestaComprobante(FACT, respuesta, exigirNcf = false) {
  if (!respuesta || typeof respuesta !== 'object') {
    if (!exigirNcf) return
    throw new Error("La respuesta DGII no identifica el comprobante actual. No se anulo ni se autorizo otro envio.")
  }
  const ncf = String(FACT.ncf || '').trim().toUpperCase()
  const emisor = FACT.facturasventa && FACT.facturasventa.sucursal
  const rnc = emisor && String(emisor.rnc || '').replace(/[-\s]/g, '')
  let identificado = false
  for (const [clave, dato] of Object.entries(respuesta)) {
    const valor = String(dato == null ? '' : dato).trim()
    if (['encf', 'ncfelectronico', 'ncf'].includes(clave.toLowerCase()) && valor) {
      identificado = true
      if (valor.toUpperCase() !== ncf) throw new Error("La respuesta DGII pertenece a otro NCF. No se anulo ni se autorizo otro envio.")
    }
    if (['rnc', 'rncemisor'].includes(clave.toLowerCase()) && valor && rnc && valor.replace(/[-\s]/g, '') !== rnc) {
      throw new Error("La respuesta DGII pertenece a otro emisor. No se anulo ni se autorizo otro envio.")
    }
  }
  if (exigirNcf && !identificado) throw new Error("La respuesta DGII no identifica el NCF actual. Consulte el comprobante antes de continuar.")
},

async DevolucionEletronicaGet(FACT){

  var trackGuardado = null
  try { trackGuardado = JSON.parse(FACT.trackId) } catch (error) { /* Todavia no hay respuesta DGII. */ }
  if (FACT.trackId && !trackGuardado) throw new Error("La respuesta DGII guardada no puede verificarse. Revise el comprobante antes de continuar.")
  this.validarRespuestaComprobante(FACT, trackGuardado, Boolean(trackGuardado && ["Aceptado", "Aceptado Condicional", "Rechazado"].includes(trackGuardado.estado)))
  if (trackGuardado && trackGuardado.estado === "Rechazado") {
    this.alerta("La nota de credito actual esta rechazada. Revise su respuesta; no se reenviara.", "error")
    return
  }
  if (trackGuardado && ["Aceptado", "Aceptado Condicional"].includes(trackGuardado.estado)) {
    var cierre = await this.devolucionAnulacion(FACT)
    this.devolucion = cierre.data
    this.enviarImprimirDevolucion(cierre.data)
    return
  }

  var CodigoModificacion=1;
var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_DEV(FACT,CodigoModificacion);;



this.validarRespuestaComprobante(FACT, resObjCompleto.objtrackId, true)
if(resObjCompleto.objtrackId.estado==="Rechazado"){
  var msj_Error=""

  Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => {
    msj_Error+=` *- COD:${element.codigo} :${element.valor} \n`
  }));

  this.alerta(msj_Error, "error")
  await this.actualizarDEV_ELETRONICA(FACT,resObjCompleto)
return
}
//this.enviarImprimirFactura(FACT)
await this.actualizarDEV_ELETRONICA(FACT,resObjCompleto)

},

async actualizarDEV_ELETRONICA(FACT,objCompTrackId){
  this.validarRespuestaComprobante(FACT, objCompTrackId.objtrackId, true)
  var TRACK =objCompTrackId.objtrackId
  //delete TRACK["mensajes"]

  var objTrack={
    documento:FACT.devoclucionPK.documento,
    secuencia:FACT.devoclucionPK.secuencia,
    ncf:FACT.ncf,
    fechafirmadgii:objCompTrackId.fechafirmadgii,
    qrdgii:objCompTrackId.qrdgii,
    signatureValue:objCompTrackId.signatureValue,
    trackId:JSON.stringify(TRACK)
  }

  if(FACT.hasOwnProperty('notacreditoclientes')&& FACT.notacreditoclientes!=null){
      await this.actualizarNOTA_CreditoCxC_ELETRONICA(FACT.notacreditoclientes, objCompTrackId)
    }

  return this.$axios.post(this.$hostname + this.$hName + "/devolucion/actualizarDevolicionEletronica",
  objTrack,{ headers: this.$store.getters.GetheadersAxios })
            .then(async (res) => {
              if(["Aceptado", "Aceptado Condicional","En Proceso"].includes(objCompTrackId.objtrackId.estado)){
                var cierre = await this.devolucionAnulacion(res.data)
                this.devolucion = cierre.data
             // this.cancelarAceptarDevolucion()
                this.enviarImprimirDevolucion(cierre.data)
              } else if (objCompTrackId.objtrackId.estado !== "Rechazado") {
                this.alerta("La nota de credito aun no esta aceptada. La factura no se ha anulado.", "warning")
              }

            //    if(objCompTrackId.objtrackId.estado==="Aceptado Condicional"){
            //     this.devolucion = res.data
            //  //this.cancelarAceptarDevolucion()
            //   this.enviarImprimirDevolucion(res.data)
            //   }

            })
            .catch((error) => {
              throw error
            });

},

actualizarNOTA_CreditoCxC_ELETRONICA(FACT, objCompTrackId) {
      this.validarRespuestaComprobante(FACT, objCompTrackId.objtrackId, true)
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.notacreditoclientesPK.documento,
        secuencia: FACT.notacreditoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }


      return this.$axios.post(this.$hostname + this.$hName + "/notacreditocliente/actualizarFactEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        .catch((error) => {
          this.alerta(error.response ? error.response.data : error, "error")
          throw error
        })

    },

devolucionAnulacion(DEV){
  //NOTA: la notacreditocontado los pendiente lo pone en 0
  //  y la factura activo lo pone false
 DEV.facturasventa.usuariosAnulacion=this.$store.getters.GetdatosInfUsu.usuario.usuario
 DEV.facturasventa.fechaAnulacion=this.fechaNueva().trim().substr(0, 10) +"T04:00"

return this.$axios.post(this.$hostname + this.$hName + "/devolucion/devolucionAnulacion",
  DEV,{ headers: this.$store.getters.GetheadersAxios })

},


enviarImprimirDevolucion(DEV){

  DEV.caja=0
  var Config = this.$store.getters.GetConfiguracionGeneral
/**/var _this = this;
setTimeout(function () {
  _this.alerta("Devolucion salvada correctamente !!!", "bien");
            if (localStorage.printerSelect != null) { }
            var selectImpre=(localStorage.printerSelect!=undefined?JSON.parse(localStorage.printerSelect):null)
            var impresora=null
            if(selectImpre!=null && selectImpre.hasOwnProperty('nombre')){
              impresora=JSON.parse(localStorage.printerSelect).nombre
              }
              var msg = {
                accion: "print",
                formato: DEV.facturasventa.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: Config,
                devolucion: DEV,
                caja: DEV.facturasventa.caja,
                cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
              };
              _this.imprimir(msg, "devolucion");
            _this.newnuevo();
}, 100);

},





 // Envío de una solicitud POST al servidor con los datos a imprimir.
    imprimir(datos, operacion) {

      datos.operacion = operacion;
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      if (datos.formato.trim() === "rolloBlue") {
if(datos.operacion.trim()==="factura"){
var FACT=datos.fac.hasOwnProperty('factura')? datos.fac.factura.factura:datos.fac
var _this = this;
setTimeout(function () {
  _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
  // _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(datos.fac.factura.factura)
}, 800);

}

      }else{
        if(datos.impresora==null){
          this.alerta(" seleccione la impresora","error")
          return
        }

        if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
           // this.newnuevo();;
          })
          .catch((error) => {
            this.ejecucion=true
            console.error(error)
          });
          }else{
            //this.cancelarUltimoDocumento();
            //this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
        .catch((error) => {
            this.ejecucion=true
            console.error(error)
          });
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
           // this.newnuevo();
          })
          .catch((error) => {
            console.error(error)
            this.ejecucion=true
          });
      }

      }


    },


    remove() {
      this.Elim_notif.estado = !this.Elim_notif.estado
    },

    eliminar() {

    },

    // Una función que se llama cuando se hace clic en una fila de la tabla.
    datostabla(e) {
      this.acti_tb_data = false;

      (this.disabled = true),
        (this.anular.documento = e.documentoFactura),
        (this.anular.factura = e.facturasventaPK.secuencia),
        (this.anular.ncf = e.ncf)
      this.anular.tipoAnulacion = e.motivoAnular

      this.RTipoAnulacion.forEach((element1) => {
        if (element1.descripcion == e.motivoAnular) {
          this.anular.tipoAnulacion = element1
        }
      })
      this.cambiaEstatus()
      this.cantRegistro(e)
      if (this.windowSize.width <= 600) {
        this.BarraPrimariaAbrir = false
      }
    },

    async filtro() {
      var obj = {
        datos: JSON.parse(JSON.stringify(this.anular)),
        usuario: JSON.parse(JSON.stringify(this.$user)),
        descripcion: this.search,
        ultimoRegistro: this.paginator.pageStart,
        paginacion: this.paginator.page,
        limite: this.paginator.itemsPerPage,
      }
    },

    // Un método que se llama cuando se hace clic en un botón y muestra un modal con todo los registro.
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.Limpiarfiltro()
    },

    // Limpieza del filtro y recarga los datos de la tabla.
    Limpiarfiltro() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      this.Modallfiltro = {
        factura: null,
        cliente: null,
        Desde: null,
        Hasta: null,
      }

      this.ListItems = []
      this.TbTotalItem = 0

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false
    },

    // Una función que se llama cuando el usuario hace clic en el botón de búsqueda y ejecuta un a api retornando los datos.
    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      if (
        this.Modallfiltro.cliente != null &&
        this.Modallfiltro.cliente.toString().length == 0
      ) {
        this.Modallfiltro.cliente = null
      }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false
    },

    // Un método que se llama cuando el usuario cambia la cantidad de elementos por página en el
    // componente de paginación.
    cargarPaginacionAll(e) {
      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      this.CargarPaginacion(e, this.Modallfiltro.factura)
    },

    // Un método que se llama cuando el usuario cambia la página de la tabla.
    CargarPaginacion(e, s) {
      this.Modallfiltro.factura = JSON.parse(JSON.stringify(s))
      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      //var pg =
      this.TbPaginator = JSON.parse(JSON.stringify(e))
      this.CargarListTb()
    },

// Comprobando si el valor de la variable anular no está indefinido y si el valor de la variable
// secuencia es mayor que 0 y si el valor de la variable activada es falso.
    cambiaEstatus() {
      this.EstadoBtn.anular = true
      if (this.anular.facturasventa != undefined && this.anular.facturasventa.activada == false) {
        this.EstadoBtn.anular = false
      }
    },
    // Hacer una llamada al servidor para obtener los datos .
    CargarListTb() {
      var cliete = null
      if (this.Modallfiltro.cliente != null) {
        cliete = this.Modallfiltro.cliente.codigo
      }
      var obj =
        this.TbPaginator.itemsPerPage +
        "/" +
        this.TbPaginator.pageStart +
        "/" +
        cliete +
        "/" +
        this.Modallfiltro.Desde +
        "/" +
        this.Modallfiltro.Hasta +
        "/" +
        this.Modallfiltro.factura

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/AnularFactura/findListAnuladaPlus/" +
          obj,
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then((res) => {
          (this.ListAnulaFact = res.data.ListAnulaFact),
            (this.TbTotalItem = res.data.TbTotalItem)
        })
    },


    validaCOntieneNCF(item){

      if(item!=null&& item.hasOwnProperty('facturasventa')&& item.facturasventa.hasOwnProperty('ncf') && item.facturasventa.ncf!=null && item.facturasventa.ncf.trim().length>0){
        return true
      }else{
          return false
      }
    },


    loading(e) {
      EventBus.$emit("loading", e);
    },

  },

  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(
        JSON.stringify(this.$store.getters.GetwindowSize),
      )
    },
  },
}
</script>

<style></style>
